import React from "react";
import { useParams, useHistory } from "react-router-dom";
import HtmlTemplateBuilder from "../../emails/htmlTemplates/HtmlTemplateBuilder";

/**
 * Wrapper component for HTML Template Builder within Pulse Reports context.
 * This reuses the existing HtmlTemplateBuilder but with pulse reports URLs.
 */
const PulseHtmlTemplateBuilder: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  // Custom back handler to go back to pulse reports html templates
  const handleBack = () => {
    history.push("/super-admin/pulse-reports/html-templates");
  };

  return (
    <HtmlTemplateBuilder
      // Pass any custom props if needed
      // The builder will use the id from params
    />
  );
};

export default PulseHtmlTemplateBuilder;
